// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"405b79e1","344":"a693ad61","453":"ef7d87eb","999":"0f56b9c5"}[chunkId] + ".chunk.js";
};